import * as Msal from 'msal'

export default class AuthService {
  constructor() {
    this.pluginOptions = {
        clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
        loginAuthority: process.env.VUE_APP_MSAL_LOGIN_AUTHORITY,
        knownAuthority: process.env.VUE_APP_MSAL_KNOWN_AUTHORITY,
        secret: process.env.VUE_APP_MSAL_SECRET
    },
    this.app = new Msal.UserAgentApplication({
        auth: {
            redirectUri: process.env.VUE_APP_REDIRECT,
            clientId: this.pluginOptions.clientId,
            clientSecret: this.pluginOptions.secret,
            authority: this.pluginOptions.loginAuthority,
            knownAuthorities: [process.env.VUE_APP_MSAL_KNOWN_AUTHORITY],
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: false
        },
        system: {
            loginRequest: {
                scopes: ["openid"],
            },
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case Msal.LogLevel.Error:
                            console.error(message);
                            return;
                        case Msal.LogLevel.Info:
                            console.info(message);
                            return;
                        case Msal.LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case Msal.LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                },
                piiLoggingEnabled: false,
                logLevel: Msal.LogLevel.Verbose
            }
        }
    })
  }

  login() {
    var loginRequest = {
        scopes: ["openid"],
    };
    
    return this.app.loginPopup(loginRequest)
  }

  loginRedirect(){
    var loginRequest = {
        scopes: ["openid"],
    };
    

    return this.app.loginRedirect(loginRequest)
  }

  logout() {
    this.app._user = null
    return this.app.logout()
  }

  getUser() {
    return this.app.getAccount()
  }
}